import React, { Component } from 'react';
import moment from 'moment';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formatDate } from 'admin/utils';
import {
  getSoftwareRelease,
  updateSoftwareRelease,
  deleteSoftwareRelease,
} from 'admin/actions/software-releases';
import LabeledCheckBox from 'admin/components/molecules/LabeledCheckBox';
import LabeledRadio from 'admin/components/molecules/LabeledRadio';
import LabeledDateTimePicker from 'admin/components/molecules/LabeledDateTimePicker';
import TextBox from 'admin/components/atoms/TextBox';
import Switch from 'react-switch';
import NumberInput from 'admin/components/atoms/NumberInput';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import Button from 'admin/components/shared/Button';
import CheckBox from 'admin/components/atoms/CheckBox';
import { openAlertModal, closeAlertModal } from 'admin/actions/alert-modal';
import FilterSelect from 'admin/components/pages/CreateSoftwareRelease/FilterSelect';

const LabelText = styled.span`
  font-weight: 600;
`;

const Hr = styled.hr`
  clear: both;
  padding: 0;
  margin: 30px 0;
`;

const ButtonsContainer = styled.div`
  margin: 30px 0;
  button {
    margin-right: 20px;
  }
`;

const FilterRadioContainer = styled.div`
  display: flex;
  ${LabeledRadio} {
    flex-grow: 1;
    cursor: pointer;
  }
`;

const FilterDetail = styled.dl`
  padding-top: 20px;
  dt, dd {
    padding: 0 !important;
  }
  dd {
    padding-left: 10px !important;
  }
`;

const SettingBox = styled.div`
  dl {
    margin: 0;
  }
  dt, dd {
    padding: 20px;
    margin: 0;
  }
`;

const CreateSoftwareReleaseContainer = styled.div`
  h5 {
    font-weight: bold;
    margin: 20px;
  }
`;

const BuildInfoContainer = styled.div`
  dl {
    margin: 0;
  }
  dt, dd {
    padding: 10px 20px;
    margin: 0;
  }
`;

const FilterAvailableRate = styled.div`
  padding-left: 5px;
  font-weight: bold;
  ${NumberInput} {
    margin: 0 5px;
  }
`;

const FilterAvailableDate = styled.div`
  margin-top: 20px;
  ${CheckBox} {
    float: left;
  }
`;

const unselect = { label: '選択して下さい', value: null };

const defaultEditingState = {
  description: '',
  is_enabled: false,
  priority: 0,
  is_force_update: false,
  available_rate: 100,
  available_from: null,
  organization_code: null,
  organization_name: null,
  private_money_uuid: null,
  private_money_name: null,
  shop_uuid: null,
  shop_name: null,
  terminal_uuid: null,
  terminal_name: null,
};

class SoftwareReleaseDetail extends Component {

  constructor(props) {
    super(props);
    this.defaultPagination = { page: 1, per_page: 25 };
    this.state = Object.assign({}, {
      selectedProductCode: unselect,
      selectedTargetHardware: unselect,
    }, defaultEditingState);
  }

  componentWillMount() {
    const { id } = this.props.match.params;
    this.props.getSoftwareRelease(id);
  }

  componentWillUpdate(nextProps) {
    if (this.props.softwareRelease !== nextProps.softwareRelease) {
      this.syncSoftwareRelease(nextProps.softwareRelease);
    }
  }

  syncSoftwareRelease(softwareRelease) {
    const r = softwareRelease;
    if (!r) return;
    this.setState({
      description: r.description,
      is_enabled: r.is_enabled,
      priority: r.priority,
      is_force_update: r.is_force_update,
      available_rate: r.available_rate,
      available_from: r.available_from ? moment(r.available_from) : null,
      organization_code: r.organization ? r.organization.code : null,
      organization_name: r.organization ? r.organization.name : null,
      private_money_uuid: r.private_money ? r.private_money.id : null,
      private_money_name: r.private_money ? r.private_money.name : null,
      shop_uuid: r.shop ? r.shop.id : null,
      shop_name: r.shop ? r.shop.name : null,
      terminal_uuid: r.terminal ? r.terminal.id : null,
      terminal_name: r.terminal ? r.terminal.name : null,
    });
  }

  onChangeAvailableRate = (e) => {
    this.setState({ available_rate: +(e.target.value) });
  }

  onChangeAvailableFrom = (date) => {
    this.setState({ available_from: date });
  }

  onChangePriority = (e) => {
    this.setState({ priority: +(e.target.value) });
  }

  onChangeDescription = (e) => {
    this.setState({ description: e.target.value });
  }

  onSelectFilterTypeAll = () => {
    this.setState({
      organization_code: null,
      private_money_uuid: null,
      shop_uuid: null,
      terminal_uuid: null,
    });
  }

  onSelectFilterTypeOrganization = () => {
    this.props.openAlertModal({
      body: (
        <FilterSelect
          target="organization"
          onSelectOrganization={(code, name) => {
            this.onSelectFilterTypeAll();
            this.setState({
              organization_code: code,
              organization_name: name,
            });
            this.props.closeAlertModal();
          }}
        />
      ),
      useCancel: false,
      useConfirm: false,
      styles: {
        content: {
          overflow: 'visible',
        },
      },
    });
  }

  onSelectFilterTypeMoney = () => {
    this.props.openAlertModal({
      body: (
        <FilterSelect
          target="money"
          onSelectPrivateMoney={(id, name) => {
            this.onSelectFilterTypeAll();
            this.setState({
              private_money_uuid: id,
              private_money_name: name,
            });
            this.props.closeAlertModal();
          }}
        />
      ),
      useCancel: false,
      useConfirm: false,
      styles: {
        content: {
          overflow: 'visible',
        },
      },
    });
  }

  onSelectFilterTypeShop = () => {
    this.props.openAlertModal({
      body: (
        <FilterSelect
          target="shop"
          onSelectShop={(id, name) => {
            this.onSelectFilterTypeAll();
            this.setState({
              shop_uuid: id,
              shop_name: name,
            });
            this.props.closeAlertModal();
          }}
        />
      ),
      useCancel: false,
      useConfirm: false,
      styles: {
        content: {
          overflow: 'visible',
        },
      },
    });
  }

  onSelectFilterTypeTerminal = () => {
    this.props.openAlertModal({
      body: (
        <FilterSelect
          target="terminal"
          onSelectTerminal={(id, name) => {
            this.onSelectFilterTypeAll();
            this.setState({
              terminal_uuid: id,
              terminal_name: name,
            });
            this.props.closeAlertModal();
          }}
        />
      ),
      useCancel: false,
      useConfirm: false,
      styles: {
        content: {
          overflow: 'visible',
        },
      },
    });
  }

  onClickedCancel = () => {
    this.props.history.goBack();
  }

  onClickedUpdate = () => {
    const { id } = this.props.match.params;
    const collectProps = (state, props) => {
      const rt = {};
      props.forEach((p) => {
        if (p in state) rt[p] = state[p];
        else rt[p] = null;
      });
      return rt;
    };
    const params = collectProps(this.state, [
      'description',
      'is_enabled',
      'priority',
      'is_force_update',
      'available_rate',
      'available_from',
      'organization_code',
      'private_money_uuid',
      'shop_uuid',
      'terminal_uuid',
    ]);
    if (params.available_from) {
      params.available_from = params.available_from.format();
    }
    this.props.openAlertModal({
      body: (
        <div>
          <strong>リリースを更新してよろしいですか？</strong>
        </div>
      ),
      useCancel: true,
      confirmText: '更新する',
      onConfirm: () => {
        this.props.updateSoftwareRelease(id, params).then(() => {
          this.props.openAlertModal({
            body: '完了しました',
            useCancel: false,
            onConfirm: () => {
              this.props.getSoftwareRelease(id);
            },
          });
        });
      },
    });
  }

  onClickedDelete = () => {
    const { id } = this.props.match.params;
    this.props.openAlertModal({
      body: (
        <div>
          <strong>リリースを削除してよろしいですか？</strong><br />
          <strong>この操作は取り消しできません</strong>
        </div>
      ),
      useCancel: true,
      confirmText: '削除する',
      confirmColor: 'danger',
      onConfirm: () => {
        this.props.deleteSoftwareRelease(id).then(() => {
          this.props.openAlertModal({
            body: '完了しました',
            useCancel: false,
            onConfirm: () => {
              this.props.history.goBack();
            },
          });
        });
      },
    });
  }

  renderBuildInfo() {
    const { software } = this.props.softwareRelease;
    return (software) ? (
      <BuildInfoContainer>
        <h5>ビルドの情報</h5>
        <dl className="row">
          <dt className="col-sm-2">プロダクトコード</dt>
          <dd className="col-sm-10">{software.product_code}</dd>

          <dt className="col-sm-2">ハードウェア</dt>
          <dd className="col-sm-10">{software.target_hardware}</dd>

          <dt className="col-sm-2">バージョンコード</dt>
          <dd className="col-sm-10">{software.version_code}</dd>

          <dt className="col-sm-2">URL</dt>
          <dd className="col-sm-10">
            <a href={software.url}>
              {software.url}
            </a>
          </dd>

          <dt className="col-sm-2">登録日時</dt>
          <dd className="col-sm-10">
            {formatDate(software.created_at)}
          </dd>

          <dt className="col-sm-2">更新日時</dt>
          <dd className="col-sm-10">
            {formatDate(software.updated_at)}
          </dd>
        </dl>
      </BuildInfoContainer>
    ) : null;
  }

  renderSettingBox() {
    const filterType = {
      all: (
        !this.state.organization_code &&
        !this.state.private_money_uuid &&
        !this.state.shop_uuid &&
        !this.state.terminal_uuid
      ),
      organization: !!this.state.organization_code,
      private_money: !!this.state.private_money_uuid,
      shop: !!this.state.shop_uuid,
      terminal: !!this.state.terminal_uuid,
    };
    const filterDetail = (() => {
      if (filterType.all) return null;
      if (filterType.organization) {
        return (
          <FilterDetail className="row">
            <dt>対象組織</dt>
            <dd>{this.state.organization_name} ({this.state.organization_code})</dd>
          </FilterDetail>
        );
      }
      if (filterType.private_money) {
        return (
          <FilterDetail className="row">
            <dt>対象マネー</dt>
            <dd>{this.state.private_money_name} ({this.state.private_money_uuid})</dd>
          </FilterDetail>
        );
      }
      if (filterType.shop) {
        return (
          <FilterDetail className="row">
            <dt>対象店舗</dt>
            <dd>{this.state.shop_name} ({this.state.shop_uuid})</dd>
          </FilterDetail>
        );
      }
      return (
        <FilterDetail className="row">
          <dt>対象ターミナル</dt>
          <dd>{this.state.terminal_name} ({this.state.terminal_uuid})</dd>
        </FilterDetail>
      );
    })();
    return (
      <SettingBox>
        <h5>設定</h5>
        <dl className="row">

          <dt className="col-sm-2">リリースの説明</dt>
          <dd className="col-sm-10">
            <TextBox
              syncValue={this.state.description}
              onChange={this.onChangeDescription}
              size={100}
            />
          </dd>

          <dt className="col-sm-2">対象絞り込み</dt>
          <dd className="col-sm-10">
            <FilterRadioContainer>
              <LabeledRadio
                name="filterType"
                onChange={this.onSelectFilterTypeAll}
                checked={filterType.all}
                labelText={(<LabelText>すべてを対象にする</LabelText>)}
                labelPosition="right"
              />
              <LabeledRadio
                name="filterType"
                onChange={this.onSelectFilterTypeOrganization}
                checked={filterType.organization}
                labelText={(<LabelText>組織で絞り込み</LabelText>)}
                labelPosition="right"
              />
              <LabeledRadio
                name="filterType"
                onChange={this.onSelectFilterTypeMoney}
                checked={filterType.private_money}
                labelText={(<LabelText>マネーで絞り込み</LabelText>)}
                labelPosition="right"
              />
              <LabeledRadio
                name="filterType"
                onChange={this.onSelectFilterTypeShop}
                checked={filterType.shop}
                labelText={(<LabelText>店舗で絞り込み</LabelText>)}
                labelPosition="right"
              />
              <LabeledRadio
                name="filterType"
                onChange={this.onSelectFilterTypeTerminal}
                checked={filterType.terminal}
                labelText={(<LabelText>特定ターミナル</LabelText>)}
                labelPosition="right"
              />
            </FilterRadioContainer>
            { filterDetail }
            <Hr />
            <FilterAvailableRate>
              上記の
              <NumberInput
                value={this.state.available_rate}
                onChange={this.onChangeAvailableRate}
                min={0}
                max={100}
              />
              ％を対象にリリース
            </FilterAvailableRate>
            <FilterAvailableDate>
              <LabeledCheckBox
                labelText={(<LabelText>即時リリース</LabelText>)}
                checked={!this.state.available_from}
                setChecked={(e) => {
                  if (!e) {
                    this.setState({ available_from: moment() });
                  } else {
                    this.setState({ available_from: null });
                  }
                }}
              />
              <br />
              <LabeledDateTimePicker
                labelText={(<LabelText>リリース日時</LabelText>)}
                value={this.state.available_from}
                onChange={this.onChangeAvailableFrom}
              />
            </FilterAvailableDate>
          </dd>

          <dt className="col-sm-2">リリースの優先度</dt>
          <dd className="col-sm-10">
            <NumberInput
              value={this.state.priority}
              onChange={this.onChangePriority}
            />
          </dd>

          <dt className="col-sm-2">強制アップデート</dt>
          <dd className="col-sm-10">
            <Switch
              checked={this.state.is_force_update}
              onChange={(checked) => {
                this.setState({ is_force_update: checked });
              }}
              width={65}
              height={30}
            />
          </dd>

          <dt className="col-sm-2">このリリースを有効化</dt>
          <dd className="col-sm-10">
            <Switch
              checked={this.state.is_enabled}
              onChange={(checked) => {
                this.setState({ is_enabled: checked });
              }}
              width={65}
              height={30}
            />
          </dd>
        </dl>
      </SettingBox>
    );
  }

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: 'サービス管理', href: '', active: true },
      { value: 'ソフトウェアリリース管理', href: '/service-settings/software-release', active: false },
      { value: '詳細', href: '', active: true },
    ];
    return (
      <CreateSoftwareReleaseContainer>
        <Breadcrumb items={crumb} />
        {this.renderBuildInfo()}
        <Hr />
        {this.renderSettingBox()}
        <ButtonsContainer>
          <Button onClick={this.onClickedUpdate}>
            リリースを更新
          </Button>
          <Button onClick={this.onClickedCancel} color="gray">
            キャンセル
          </Button>
          <Button onClick={this.onClickedDelete} color="danger" style={{ float: 'right' }}>
            リリースを削除
          </Button>
        </ButtonsContainer>
      </CreateSoftwareReleaseContainer>
    );
  }
}

SoftwareReleaseDetail.defaultProps = {
  softwareRelease: {
    software: {},
  },
};

const mapStateToProps = state => ({
  softwareRelease: state.softwareRelease.softwareRelease,
});

SoftwareReleaseDetail.propTypes = {
  openAlertModal: PropTypes.func.isRequired,
  closeAlertModal: PropTypes.func.isRequired,
  getSoftwareRelease: PropTypes.func.isRequired,
  updateSoftwareRelease: PropTypes.func.isRequired,
  deleteSoftwareRelease: PropTypes.func.isRequired,
  softwareRelease: PropTypes.shape({
    software: PropTypes.shape({}),
  }),
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  openAlertModal,
  closeAlertModal,
  getSoftwareRelease,
  updateSoftwareRelease,
  deleteSoftwareRelease,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SoftwareReleaseDetail);
